import { memo } from 'react';

import { SegmentedControlRow } from '~/components/ShareModal/components/SegmentedControlRow';
import { useShareBoardDesign } from '~/components/SharePrivateBoardModal/ShareBoardDesignProvider';

/** Page width segmented control, bound to the board design context. */
export const ShareBoardDesignPageWidthRow = memo(() => {
  const { pageWidthOptions, selectedPageWidthOption, handleSelectPageWidth } = useShareBoardDesign();

  return (
    <SegmentedControlRow
      data-testid="SHARE_BOARD_DESIGN_PAGE_WIDTH_ROW"
      label="Page width"
      onSelect={handleSelectPageWidth}
      options={pageWidthOptions}
      selectedOption={selectedPageWidthOption}
    />
  );
});

ShareBoardDesignPageWidthRow.displayName = 'ShareBoardDesignPageWidthRow';
